module.exports = __webpack_public_path__ + "img/726-d62279.png";